import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
    selector: 'app-svg-benne',
    templateUrl: './svg-benne.component.html',
    styleUrls: ['./svg-benne.component.css'],
    standalone: false
})
export class SvgBenneComponent implements OnInit {
  @Input() darkcolor;
  @Input() lightcolor;

  constructor() { }

  ngOnInit() {
  }

}
